import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SITE_URL = "https://her-season.lovable.app";
const DEFAULT_TITLE = "Her Season — Your Journey, Your Power";
const DEFAULT_DESC =
  "Her Season is a warm, science-backed companion for perimenopause and menopause — track symptoms, find relief, and journey through this chapter with power.";

type SEOProps = {
  title?: string;
  description?: string;
  canonical?: string;
  ogType?: "website" | "article" | "product";
  image?: string;
  jsonLd?: object | object[];
  noindex?: boolean;
};

export const SEO = ({
  title,
  description = DEFAULT_DESC,
  canonical,
  ogType = "website",
  image,
  jsonLd,
  noindex,
}: SEOProps) => {
  const { pathname } = useLocation();
  const url = canonical || `${SITE_URL}${pathname}`;
  const fullTitle = title
    ? title.length > 60
      ? title
      : `${title} — Her Season`
    : DEFAULT_TITLE;
  const desc = description.slice(0, 160);
  const jsonLdArray = jsonLd
    ? Array.isArray(jsonLd)
      ? jsonLd
      : [jsonLd]
    : [];

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={url} />
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {image && <meta name="twitter:image" content={image} />}
      {jsonLdArray.map((data, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(data)}
        </script>
      ))}
    </Helmet>
  );
};

export default SEO;
